import { IResourceConfig } from '@/Core/Contracts/UI'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'
import { dictionaryDeleteConfirmText, dictionaryDetailButtons } from '../Helpers/dictionaryDelete'

export const ListLoadingPointResource: IResourceConfig = {
    title: 'Пункти навантаження/розвантаження',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            isRequired: true,
            type: 'string',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        address: {
            label: 'Адреса',
            type: 'string',
        },
        warehouseTitle: {
            label: 'Склад',
            type: 'string',
        },
        type: {
            label: "Тип об'єкта",
            type: 'select',
            resource: 'Setting.ListObjectType',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        productionObject: {
            label: "Об'єкт виробництва",
            type: 'select',
            resource: 'Setting.ListProductionObject',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        constructionObject: {
            label: "Об'єкт будівництва",
            type: 'select',
            resource: 'Setting.ListConstructionObject',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        code: {
            label: 'Код',
            isRequired: true,
            type: 'string',
            depFn: ({ formContext, field }) => {
                field.mergeInputProps({ disabled: formContext.values?.id > 0 })
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: [
            'id',
            'title',
            'code',
            'isActive',
            'warehouseTitle',
            'type',
            'productionObject',
            'constructionObject',
            'externalCode',
        ],
    },
    /** Картка колекції всередині оболонки розділу «Довідники» */
    layout: DictionariesShell,
    restUrl: '/services/lists/loading-points',
    pageUrl: '/settings/loading-points',
    primaryFieldCode: 'code',
    /** «Видалити» в шапці картки (ядро дає лише пункт у меню рядка) */
    detailConfig: { onButtons: dictionaryDetailButtons },
    settings: {
        /** Попередження в підтвердженні видалення запису з ERP */
        deleteConfirmText: dictionaryDeleteConfirmText,
        searchFields: ['id', 'code', 'title'],
    },
}
